export enum EsignatureType {
  Adobesign = 'adobesign',
  Docusign = 'docusign',
  DocusignDemo = 'docusign_demo',
}
